import { useCallback, useEffect } from 'react';
import { PrimitiveAtom, useAtomValue, useSetAtom } from 'jotai';
import queryString from 'query-string';
import { updateUrl } from '@/utils';

export type AssemblyDeeplinkState = {
  shouldUpdateUrl: boolean;
  selectedAssemblyNameAtom: PrimitiveAtom<string | undefined>;
  onAssemblyParsed?: (tagName: string) => void;
};

export const useAssemblyDeeplink = (state: AssemblyDeeplinkState) => {
  const { shouldUpdateUrl, selectedAssemblyNameAtom, onAssemblyParsed } = state;

  const selectedAssemblyName = useAtomValue(selectedAssemblyNameAtom);
  const setSelectedAssemblyName = useSetAtom(selectedAssemblyNameAtom);

  useEffect(() => {
    if (shouldUpdateUrl) {
      updateUrl('assembly', selectedAssemblyName);
    }
  }, [shouldUpdateUrl, selectedAssemblyName]);

  const applyFromParsed = useCallback(
    (parsed: queryString.ParsedQuery<string>) => {
      if (parsed.assembly) {
        const tagName = parsed.assembly.toString();
        if (tagName) {
          setSelectedAssemblyName(tagName);
          onAssemblyParsed?.(tagName);
        }
      }
    },
    [setSelectedAssemblyName, onAssemblyParsed]
  );

  return { applyFromParsed };
};
